import React, { useState } from "react";
import "./ReplyModal.css";
import { Trash2, Link2, Paperclip } from "lucide-react";
const apiUrl = process.env.REACT_APP_API_BASE_URL;
const ReplyModal = ({ user, onClose }) => {
    const [message, setMessage] = useState("");
    const [sending, setSending] = useState(false);
    const [success, setSuccess] = useState(null);

    const handleSendEmail = async () => {
        if (!message.trim()) {
            alert("Message cannot be empty!");
            return;
        }

        setSending(true);

        try {
            const response = await fetch(`${apiUrl}/api/auth/send-email`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    to: user.email,
                    subject: `Reply to your inquiry: ${user.query || "Inquiry"}`,
                    text: message
                })
            });

            const data = await response.json();
            if (response.ok) {
                setSuccess("Email sent successfully!");
            } else {
                setSuccess(`Failed: ${data.message}`);
            }
        } catch (error) {
            setSuccess("Error sending email");
        }

        setSending(false);
        setTimeout(() => setSuccess(null), 3000);
    };

    return (
        <div className="modal-overlay">
            <div className="modal-container">
                <h3>Reply</h3>
                <div className="user-info">
                    <span className="arrow-icon">↩</span>
                    <span className="user-name">{user.name}</span>
                    <span className="user-email">({user.email})</span>
                </div>
                <input type="text" className="query-input" value={user.query} readOnly />
                <textarea
                    className="reply-textarea"
                    placeholder="Write a response to this query.."
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                />
                <div className="actions">
                    <button className="send-btn" onClick={handleSendEmail} disabled={sending}>
                        {sending ? "Sending..." : "Send"}
                    </button>
                    <span className="attachment-icon"><Paperclip /></span>
                    <span className="link-icon"><Link2 /></span>
                    <span className="delete-icon"><Trash2 /></span>
                </div>
                {success && <p className="success-message">{success}</p>}
                <button className="close-btn" onClick={onClose}>✖</button>
            </div>
        </div>
    );
};

export default ReplyModal;
